export const actionTypes = {
  FETCH_PERSON_FAMILY_MEMBERS: 'MEMBER_PORTAL/FETCH_PERSON_FAMILY_MEMBERS',
  FETCH_PERSON_FAMILY_MEMBERS_LOADING: 'MEMBER_PORTAL/FETCH_PERSON_FAMILY_MEMBERS_LOADING',
  DELETE_PERSON_FAMILY_MEMBER: 'MEMBER_PORTAL/DELETE_PERSON_FAMILY_MEMBER',
  ADD_PERSON_FAMILY_MEMBER: 'MEMBER_PORTAL/ADD_PERSON_FAMILY_MEMBER',
  ADD_PERSON_FAMILY_MEMBER_LOADING: 'MEMBER_PORTAL/ADD_PERSON_FAMILY_MEMBER_LOADING',
  RESET_ADD_PERSON_FAMILY_MEMBER_ACTION_RESULT:
    'MEMBER_PORTAL/RESET_ADD_PERSON_FAMILY_MEMBER_ACTION_RESULT',
};
